import { Link, useHistory } from 'react-router-dom'
import * as S from './styles'
import {
  getLastTrackingColor,
  //changePedidoStatusToTag,
  //getPedidoStatusColor,
  getSortedStatusByDate
  //preenchimentoCor
} from './utils'
import { OrderProps } from '../../types/pedidos'
import { capitalizeWord, capitalizeFirstLetter } from '../../utils/utils'

interface FichaPedidoProps {
  pedidos: OrderProps[]
}

const FichaPedido = ({ pedidos }: FichaPedidoProps) => {
  const history = useHistory()

  const changePagamentoMessage = (pedido: OrderProps) => {
    const tipoPagamento = pedido?.Pagamento?.PagamentoTipo

    const descricaoPagamento = pedido?.Pagamento?.PagamentoDescricao

    const juros = pedido?.Juros

    const quantidadeParcelas = pedido?.QuantidadeParcelas

    // const valorParcela = pedido?.ValorParcela

    if (tipoPagamento === 'BOLETO' && descricaoPagamento === 'BOLETO_A_VISTA') {
      return (
        <>
          {pedido?.Pagamento?.Condicao} (
          <Link
            onClick={() => {
              window.open(
                `${process.env.REACT_APP_URL_MAIN}/bradesco/gerarboleto/?idpedido=${pedido?.IdPedido}`
              )
            }}
            to={'#'}
          >
            2ª via aqui
          </Link>
          )
        </>
      )
    }

    if (descricaoPagamento === 'BOLETO_GIMBA_FATURADO') {
      if (juros === '0,00%') {
        return pedido?.Pagamento?.Condicao
      } else if (juros !== '0') {
        return `${pedido?.Pagamento?.Condicao} ${juros}`
      } else {
        return pedido?.Pagamento?.Condicao
      }
    }

    switch (tipoPagamento) {
      case 'CARTAO_DE_CREDITO':
        if (
          pedido.Pagamento?.Situacao === 'FALHA' &&
          pedido.StatusPedido !== 'PEDIDO_CANCELADO'
        ) {
          return (
            <>
              Não Aprovado (
              <Link to={`/dados-pagamento/${pedido.IdPedido}`}>Verificar</Link>)
            </>
          )
        } else if (
          pedido.Pagamento?.Situacao === 'FALHA' &&
          pedido.StatusPedido === 'PEDIDO_CANCELADO'
        ) {
          return <>Não Aprovado</>
        } else {
          return `${quantidadeParcelas}x Cartão de Crédito`
        }

      default:
        return pedido.Pagamento?.Condicao
    }
  }

  return (
    <>
      {pedidos?.map((pedido) => {
        return (
          <S.Wrapper key={pedido?.IdPedido}>
            <S.CardInfo>
              <p className="numero">
                <strong>Nº {pedido?.IdPedido}</strong>
              </p>

              <p>
                <strong>Data: </strong>
                {pedido?.DataPedido} às {pedido?.HoraPedido}
              </p>

              <p>
                <strong>Pagamento: </strong>
                {changePagamentoMessage(pedido)}
              </p>

              <p>
                <strong>Valor: </strong>
                {pedido?.ValorTotalPedido}
              </p>
            </S.CardInfo>
            {pedido?.EnderecoEntrega ? (
              <S.Tag
                color={capitalizeWord(getLastTrackingColor(pedido?.Remessas))}
              >
                <a
                  href="#"
                  onClick={() => {
                    history.push(`/meus-pedidos/${pedido?.IdPedido}`, {
                      redirect: false,
                      from: 'meus-pedidos'
                    })
                  }}
                >
                  {capitalizeFirstLetter(
                    pedido?.Remessas.length > 1
                    ? 'Consultar Entregas'
                    : getSortedStatusByDate(pedido?.Remessas, pedido)
                  )}
                </a>
              </S.Tag>
            ) : (
              ''
            )}
            <div className="detalhe-link">
              <button
                onClick={() => {
                  history.push(`/meus-pedidos/${pedido?.IdPedido}`, {
                    redirect: false,
                    from: 'meus-pedidos'
                  })
                }}
              >
                Detalhes do pedido
              </button>
            </div>
          </S.Wrapper>
        )
      })}
    </>
  )
}

export default FichaPedido
